export var valuesWorkflowDenialAction = ["Restart", "GoBack", "Goto"];
/*

*/ 
//# sourceMappingURL=WorkflowDenialAction.js.map